// @mui
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
// utils
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import CustomPopover, {usePopover} from 'src/components/custom-popover';
import {useSelector} from 'react-redux'
import Button from '@mui/material/Button'
import {dispatch} from '../../store/store'
import {endpointSlice} from '../../store/endpoint/endpoingSlice'
import {useNavigate} from 'react-router-dom'
import {ListSubheader, Skeleton, Stack} from '@mui/material';
import {useResponsive} from 'src/hooks/use-responsive';
import {employeesApi} from 'src/store/employees/employeesApi';
import LoadingLine from 'src/components/loading-line/LoadingLine';
import {usePlatform} from 'src/hooks/use-platform';
// ----------------------------------------------------------------------

export default function ContactsPopover() {
  const popover = usePopover();
  const {endpoints, selectedEndpoint} = useSelector(store => store.endpoint)
  const userLoading = useSelector(store => store.user.loading)
  const userData = useSelector(store => store?.user?.permissions?.user_data)
  const employeeId = userData?.employee_id
  const [triggerUpdateEmployeeId, updateEmployeeIdQuery] = employeesApi.useLazyUpdateEmployeeIdEndpointQuery()


  const navigate = useNavigate()

  const smDown = useResponsive('down', 'sm')
  const {isPlatformOwner, isCustomerMerchant} = usePlatform()

  const sortedEndpoints = [...(endpoints.data ?? [])].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'ru')
  )
  // Владелец платформы видит и свои точки, и точки заказчиков — вперемешку их
  // не отличить, поэтому разводим по группам.
  const customerEndpoints = isPlatformOwner
    ? sortedEndpoints.filter(endpoint => isCustomerMerchant(endpoint.merchant_id))
    : []
  const endpointGroups = customerEndpoints.length
    ? [
      {
        title: 'Мои точки',
        items: sortedEndpoints.filter(endpoint => !isCustomerMerchant(endpoint.merchant_id)),
      },
      {title: 'Точки заказчиков', items: customerEndpoints},
    ].filter(group => group.items.length)
    : [{title: null, items: sortedEndpoints}]
  const selectEndpoint = async (endpoint) => {
    triggerUpdateEmployeeId({id: employeeId, endpoint_id: endpoint.id})
    dispatch(endpointSlice.actions.selectEndpoint(endpoint))
    popover.onClose()
    navigate('/operations')
  }

  return (
    <>
      {/*{selectedEndpoint && (*/}
      {/*  <Box>*/}
      {/*    <ListItemText*/}
      {/*      primary={selectedEndpoint.name}*/}
      {/*      secondary={selectedEndpoint.short_name}*/}
      {/*      primaryTypographyProps={{typography: 'subtitle2'}}*/}
      {/*      secondaryTypographyProps={{*/}
      {/*        typography: 'caption',*/}
      {/*        color: 'text.disabled',*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  </Box>*/}
      {/*)}*/}

      {userLoading ? (
        <Stack sx={{mr: ' auto'}}>
          <LoadingLine width={140} height={40} dark />
        </Stack>
      ) : (
        <Button
          variant="link"
          onClick={popover.onOpen}
          sx={{
            mr: 'auto',
            ...(popover.open && {
              bgcolor: (theme) => theme.palette.action.selected,
            }),
          }}
        >
          <Stack sx={{textAlign: 'left'}} direction='row' alignItems="center">
            <ListItemText
              primary={selectedEndpoint?.name}
              primaryTypographyProps={{typography: 'subtitle2'}}
              secondaryTypographyProps={{
                typography: 'caption',
                color: 'text.disabled',
              }}
            />
            <Iconify sx={{marginLeft: '8px', width: '18px', Height: '18px'}} icon="iconamoon:arrow-down-2-duotone" />
          </Stack>
        </Button>
      )}

      <CustomPopover arrow='top-left' open={popover.open} onClose={popover.onClose} sx={{width: 320, overflow: "auto", p: 0, mt: smDown ? 2.5 : 1.5}}>

        <Scrollbar>
          {endpointGroups.map((group) => (
            <div key={group.title ?? 'all'}>
              {group.title && (
                <ListSubheader
                  disableSticky
                  sx={{
                    typography: 'overline',
                    color: 'text.disabled',
                    lineHeight: '32px',
                    px: 1,
                  }}
                >
                  {group.title}
                </ListSubheader>
              )}
              {group.items.map((endpoint) => (
                <MenuItem key={endpoint.id} sx={{p: 1}}>
                  <ListItemText
                    primary={endpoint.name}
                    secondary={endpoint.address}
                    primaryTypographyProps={{typography: 'subtitle2'}}
                    secondaryTypographyProps={{
                      typography: 'caption',
                      color: 'text.disabled',
                    }}
                    onClick={() => selectEndpoint(endpoint)}
                  />
                </MenuItem>
              ))}
            </div>
          ))}
        </Scrollbar>
      </CustomPopover>
    </>
  );
}
